import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';

const ChangeMonthlyPaymentFailed = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('ChangeMonthlyPaymentFailed.title')}>
      <p>{t('ChangeMonthlyPaymentFailed.info')}</p>
      <ModalActions>
        <Button onClick={closeModal}>{t('ChangeMonthlyPaymentFailed.button')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default ChangeMonthlyPaymentFailed;
